"use client";

import TopNavThree from "../../components/Header/TopNav/TopNavThree";
import MenuFurniture from "../../components/Header/Menu/MenuFurniture";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import Footer from "../../components/Footer/Footer";
import * as Icon from "@phosphor-icons/react/dist/ssr";

const OrderTracking = () => {
  return (
    <>
      <TopNavThree props="style-three bg-white" />
      <div id="header" className="relative w-full">
        <MenuFurniture props="" />
        <Breadcrumb heading="Order Tracking" subHeading="Order Tracking" />
      </div>
      <div className="order-tracking md:py-20 py-10">
        <div className="container">
          <div className="content-main flex gap-y-8 max-md:flex-col">
            <div className="left md:w-1/2 w-full lg:pr-[60px] md:pr-[40px] md:border-r border-line">
              <div className="heading4">Suivi de Commande</div>
              <div className="mt-2">
                Pour suivre votre commande, veuillez entrer votre ID de commande
                dans la boîte ci-dessous et appuyer sur le bouton{" "}
                {String.raw`"`}Suivi{String.raw`"`}. Cela vous a été donné sur
                votre reçu et dans l&apos;email de confirmation que vous devriez
                avoir reçu.
              </div>
              <form className="md:mt-7 mt-4">
                <div className="email ">
                  <input
                    className="border-line px-4 pt-3 pb-3 w-full rounded-lg"
                    id="username"
                    type="email"
                    placeholder="Nom d'utilisateur ou adresse email *"
                    required
                  />
                </div>
                <div className="billing mt-5">
                  <input
                    className="border-line px-4 pt-3 pb-3 w-full rounded-lg"
                    id="billing"
                    type="email"
                    placeholder="Email de facturation *"
                    required
                  />
                </div>
                <div className="block-button md:mt-7 mt-4">
                  <button className="button-main">Suivi des Commandes</button>
                </div>
              </form>
            </div>
            <div className="right md:w-1/2 w-full lg:pl-[60px] md:pl-[40px] flex items-center">
              <div className="text-content">
                <div className="heading4">Vous avez déjà un compte ?</div>
                <div className="mt-2 text-secondary">
                  Bienvenue de nouveau. Connectez-vous pour accéder à votre
                  expérience personnalisée, vos préférences enregistrées, et
                  plus encore. Nous sommes ravis de vous avoir à nouveau avec
                  nous !
                </div>
                <div className="block-button md:mt-7 mt-4">
                  <a href={"/login"} className="button-main">
                    Connexion
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default OrderTracking;
